import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

async function normalizarParaSalvar(contratos) {

  var contratosSelecionado = "";

  for (var i = 0; i < contratos.length; i++) {
    if (contratos[i].selecionado == "1") {
      contratosSelecionado += contratos[i].idContratoCrypt + ";";
    }
  }

  return contratosSelecionado;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/contratos', { params: parametros }).then(response => response.data);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/contratos/${id}`).then(response => response.data);
  },
  liberar: id => {
    return Vue.http.put(`/api/contratos/${id}/liberar`).then(response => response.data);
  },
  liberarContratos: async (contratos) => {
    contratos = await normalizarParaSalvar(contratos); 

    return Vue.http.put(`/api/contratos/${contratos}/liberarcontratos`).then(res => res.data);
  },
  permissaoLiberarContrato: (idContrato) => {
    return Vue.http.get(`/api/contratos/${idContrato}/permissaoliberar`).then(response => response.data);
  },
  listaLiberados: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/contratos/liberados', { params: parametros });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/contrato/servico.js